import React, { useEffect, useState } from 'react'
import { Dropdown } from '../Dropdown/index.js'
import { Calendar } from './Calendar.js'
import { format } from 'date-fns'
import { Style } from 'inlines'
import { LabelDescription } from '../LabelDescription/index.js'

type DateInputProps = {
  value?: number // milliseconds elapsed since the epoch (so like Date.now())
  onChange: (value: number) => void
  variant: 'date' | 'date-time'
  error?: boolean
  disabled?: boolean
  placeholder?: string
  style?: Style
  label?: string
  description?: string
  errorMessage?: string
  selectableRange?: {
    min?: number | Date
    max?: number | Date
  }
}

const DateInput = ({
  value,
  onChange,
  variant = 'date-time',
  error,
  disabled,
  placeholder,
  style,
  label,
  description,
  errorMessage,
  selectableRange,
}: DateInputProps) => {
  const [open, setOpen] = useState(false)

  const formattedValue = value
    ? format(
        new Date(value),
        variant === 'date-time' ? 'MMM d, yyy HH:mm' : 'MMM d, yyy',
      )
    : undefined

  // console.log({ formattedValue, value })

  return (
    <LabelDescription
      label={label}
      description={description}
      error={error && errorMessage}
      style={{ width: '100%' }}
    >
      <Calendar
        variant={variant}
        value={value}
        onChange={onChange}
        setOpen={setOpen}
        selectableRange={selectableRange}
      >
        <Dropdown
          open={open}
          style={{ width: '100%', minWidth: 240, ...style }}
          error={error}
          leadIcon="calendar"
          disabled={disabled}
          placeholder={placeholder}
          value={formattedValue}
        />
      </Calendar>
    </LabelDescription>
  )
}

export { DateInput, Calendar as CalendarDropdown }
export type { DateInputProps }
